import { render } from "./PopupSuccessfully.vue?vue&type=template&id=b0707f14&scoped=true"
import script from "./PopupSuccessfully.vue?vue&type=script&lang=js"
export * from "./PopupSuccessfully.vue?vue&type=script&lang=js"

import "./PopupSuccessfully.vue?vue&type=style&index=0&id=b0707f14&lang=scss&scoped=true"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0707f14"]])

export default __exports__